import { SubscriptionLayoutOption } from '@/src/types/common/SalesChannel';
import { ResponsiveSubscriptionModule } from '@/src/types/common/content';
import { EnumModuleType } from '@/src/types/common/module';

type Params = {
  pc: ResponsiveSubscriptionModule;
  tablet: ResponsiveSubscriptionModule;
  mobile: ResponsiveSubscriptionModule;
  moduleType: EnumModuleType;
};

class SubscriptionStrategy {
  assign(obj: any, target: any) {
    Object.assign(obj, target);
  }

  copyStrategy({ pc }: any) {
    return {
      ...pc,
      layoutOption: SubscriptionLayoutOption.ONE_COLUMN,
    };
  }

  invokeStrategy({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const {
      submitButtonText,
      fields,
      tacs,
      animation,
      moduleStyle,
      buttonThemeUuid,
      subscriptionFormStyle,
    } = pc;
    if (
      Reflect.ownKeys(pc).length > 0 &&
      !Reflect.ownKeys(tablet)?.length &&
      !Reflect.ownKeys(mobile).length
    ) {
      this.assign(_tablet, { moduleStyle, buttonThemeUuid });
      this.assign(_mobile, { moduleStyle, buttonThemeUuid });
    }
    this.assign(_tablet, {
      layoutOption: SubscriptionLayoutOption.ONE_COLUMN,
      submitButtonText,
      animation,
      subscriptionFormStyle,
      moduleStyle: {
        ...tablet.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
      fields,
      tacs,
    });
    this.assign(_mobile, {
      layoutOption: SubscriptionLayoutOption.ONE_COLUMN,
      submitButtonText,
      animation,
      subscriptionFormStyle,
      moduleStyle: {
        ...mobile.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
      },
      fields,
      tacs,
    });
    return {
      pc,
      tablet: _tablet,
      mobile: _mobile,
    };
  }
}

export default new SubscriptionStrategy();
